<div class="py-8 bg-frame">
  <div class="text-center my-4 fs-5">{{'ThisSectionIsBeingUpdated' | translate}}</div>
  <img src="/assets/images/loading/loading.jpeg" class=" d-flex col-lg-4 col-12 px-4 m-auto"
       alt="">
</div>

